/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Material
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

// Components
import DatePicker from 'components/DateRange/DateRange';

// Styles
import useStyles from './periodFilter.styles';

interface PeriodProps {
  startDate: Date;
  endDate: Date;
  startOnChange: (date: Date | null) => void;
  endOnChange: (date: Date | null) => void;
}

const PeriodFilter: React.FC<PeriodProps> = ({
  startDate,
  endDate,
  startOnChange,
  endOnChange,
}) => {
  const classes = useStyles();

  return (
    <Box component='div'>
      <Typography variant='h5' className={classes.periodLabel}>
        Escolha uma data de inicio e uma data de fim para filtrar por um
        determinado periodo.
      </Typography>

      <DatePicker
        startValue={startDate}
        startOnChange={startOnChange}
        endValue={endDate}
        endOnChange={endOnChange}
      />
    </Box>
  );
};

export { PeriodFilter };
export default PeriodFilter;
